/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgMessages = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="m19 14 3 6h-6zm3-10v8h-2V6H4v10h11v2H2V4zm-9 8v2H6v-2zm4-4v2H6V8z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgMessages as Messages };
